// removed by extract-text-webpack-plugin
module.exports = {"ButtonContainer":"ButtonContainer__dTVh6"};


//////////////////
// WEBPACK FOOTER
// ./routes/HelpDesk/HelpDeskArticle/Feedback/Button/style.scss
// module id = Zj7u
// module chunks = 0